import React, {Component} from 'react';
import {Dialog} from 'primereact/dialog';
import {MultiSelect} from "primereact/multiselect";
import {estados} from "../../util/estados";
import ListagemEmpreendimentos from "./ListagemEmpreendimentos";
import Pagination from "react-js-pagination";

class ModalProcurarEmpreendimento extends Component {

    constructor(props) {
        super(props);
        this.state = {
            empreendimentos: [],
            cidades_options: [],
            loading_cidades: false,
            filters: {
                nome_cidade: [], estados: [], status: []
            }, loading: false, pagination: {
                current_page: 1, per_page: 30, total: 0, from: 0, to: 0
            }
        };
    }

    componentDidMount = async () => {
        window.addEventListener('setFilters', this.handleSetFilters);
        await this.buscar();
    }

    handleCidadeChanged = (event) => {
        this.setState({
            filters: {
                ...this.state.filters, nome_cidade: event.value
            }
        });
    }

    handleEstadosChanged = async (event) => {
        await this.setState({
            filters: {
                ...this.state.filters, estado: event.value
            }
        });

        await this.loadCidades();
    }

    setLoading = (loading) => {
        this.setState({
            loading: loading
        });
    }

    loadCidades = async () => {
        try {
            await this.setState({
                ...this.state,
                loading_cidade: true
            });

            const response = await axios.get(route('web.municipios.index', {
                ufs: this.state.filters.estado,
            }));

            await this.setState({
                ...this.state, cidades_options: response.data,
            })

        } catch (error) {
            console.log(error);
        } finally {
            await this.setState({
                ...this.state,
                loading_cidade: false
            });
        }
    }

    handleValueChanged = (event) => {
        this.setState({
            filters: {
                ...this.state.filters, [event.target.name]: event.target.value
            }
        });
    }


    buscar = async () => {
        try {
            await this.setLoading(true);
            let response = await axios.get(route('building.index', {
                ...this.state.filters, page: this.state.pagination.current_page,
            }));

            this.setState({
                ...this.state, empreendimentos: response.data.data, pagination: {
                    ...this.state.pagination,
                    current_page: response.data.current_page,
                    per_page: response.data.per_page,
                    total: response.data.total,
                    to: response.data.to,
                    from: response.data.from
                }
            })
        } catch (e) {

        } finally {
            await  this.setLoading(false);
        }
    }

    handlePageChange = async (pageNumber) => {
        await this.setState({
            ...this.state, pagination: {
                ...this.state.pagination, current_page: pageNumber
            }
        });

        await this.buscar();
    }

    componentWillUnmount() {
        window.removeEventListener('setFilters', this.handleSetFilters);
    }

    handleSetFilters = async (e)=>{

        console.log(e);


        let estado = e.detail.estado

        if( estado.length > 0 ){
            await this.setState({
                filters: {
                    ...this.state.filters,
                    ...e.detail
                }
            });

            await this.loadCidades();
        }

        await this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                nome: e.detail.nome,
                nome_cidade: e.detail.nome_cidade
            }
        })

        await this.buscar();
    }


    render() {
        return (<React.Fragment>
                <Dialog onHide={this.props.onHide}
                        header="Procurar Empreendimento"
                        visible={this.props.visible}
                        style={{width: '75vw', zIndex: 19999}}
                >
                    <div className="container-fluid" style={{height: '70vh', marginBottom: '10px'}}>

                        <div className="row">
                            <div className="col-12 col-md-4 col-sm-4">
                                <label htmlFor="nome_empreendimento">
                                    Empreendimento
                                </label>
                                <input type="text" name="nome" id="nome_empreendimento"
                                       onChange={this.handleValueChanged}
                                       value={this.state.filters.nome}
                                       className="form-control"/>
                            </div>
                            <div className="col-12 col-md-3 col-sm-3">
                                <label htmlFor="estado">Estado</label> <br/>
                                <MultiSelect
                                    name="estado"
                                    placeholder="Selecione os Estados"
                                    style={{width: '100%'}}
                                    value={this.state.filters.estado}
                                    options={estados}
                                    display="chip"
                                    appendTo={document.body}
                                    onChange={this.handleEstadosChanged}
                                    filter
                                />
                            </div>
                            <div className="col-12 col-md-3 col-sm-3">
                                <label htmlFor="cidade">Cidade</label> <br/>
                                <MultiSelect
                                    placeholder="Selecione as Cidades"
                                    style={{width: '100%'}}
                                    value={this.state.filters.nome_cidade}
                                    options={this.state.cidades_options}
                                    display="chip"
                                    appendTo={document.body}
                                    disabled={this.state.loading_cidades}
                                    onChange={this.handleCidadeChanged}
                                    filter
                                />

                            </div>
                            <div className="col-12 col-md-2 col-sm-2">
                                <div className="d-flex justify-content-center align-items-end" style={{height: '100%'}}>
                                    <button className="btn btn-sm btn-block btn-primary" onClick={this.buscar}>Buscar</button>
                                </div>
                            </div>
                        </div>
                        <hr/>

                        <ListagemEmpreendimentos loading={this.state.loading} empreendimentos={this.state.empreendimentos}/>

                        {!this.state.loading && this.state.empreendimentos.length > 0 && (
                            <div className="d-flex justify-content-center" style={{marginBottom: '5px'}}>
                                <Pagination
                                    activePage={this.state.pagination.current_page}
                                    itemsCountPerPage={this.state.pagination.per_page}
                                    totalItemsCount={this.state.pagination.total}
                                    pageRangeDisplayed={10}
                                    onChange={this.handlePageChange}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                />
                            </div>
                        )}
                    </div>
                </Dialog>
            </React.Fragment>)

    }
}

export default ModalProcurarEmpreendimento;
